import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { _className, ComponentSync, EditableItem, LL_H_C, LL_V_L, stopPropagation } from '@nu-art/thunderstorm-frontend/index';
import { formatTimestamp } from '@nu-art/ts-common';
import './Renderer_SmartLog.scss';
import { SmartDocsType_Enum } from '@app/advisor-shared';
import { ModuleFE_ScrollBar } from '@app/styles/frontend/modules/ModuleFE_ScrollBar/ModuleFE_ScrollBar';
import { ICONS } from '@app/styles';
export class Renderer_SmartLog extends ComponentSync {
    //######################### Life Cycle #########################
    deriveStateFromProps(nextProps, state) {
        state.editable ??= this.getEditable(nextProps.smartDoc);
        state.expanded ??= false;
        return state;
    }
    //######################### Logic #########################
    getEditable(item) {
        return new EditableItem(item).setSaveAction(async (item) => {
            this.logInfo('Saving doc');
            // TODO: Implement a real comment api in the em then re add
            // const doc = await ModuleFE_RuntimeSmartDoc._v1.updateComments(item).executeSync();
            this.setState({ editable: this.getEditable(item), editedComment: undefined });
            return item;
        });
    }
    toggleExpand = (e) => {
        this.setState({ expanded: !this.state.expanded }, () => {
            if (this.props.scrollRef)
                ModuleFE_ScrollBar.updateScrollBar(this.props.scrollRef);
        });
    };
    handleBodySelection = (e) => {
        const selection = window.getSelection();
        if (selection && selection.toString().length > 0)
            e.stopPropagation();
    };
    //######################### Render #########################
    render() {
        return _jsxs(LL_H_C, { onClick: this.toggleExpand, className: 'smart-doc', children: [this.renderHeader(), this.renderInfoContainer()] });
    }
    renderHeader = () => {
        const smartDoc = this.state.editable.item;
        const ghostTextClassName = _className('ghost-text', this.state.expanded && 'expanded');
        return _jsxs(LL_V_L, { className: 'smart-doc__header', children: [_jsx("span", { className: 'smart-doc__header__title', children: smartDoc.text.title }), _jsx("span", { onClick: this.handleBodySelection, className: ghostTextClassName, children: smartDoc.text.body })] });
    };
    renderInfoContainer = () => {
        const smartLog = this.state.editable.item;
        const canEdit = smartLog.smartDocType === SmartDocsType_Enum.PHYSICIAN_NOTE && smartLog._id;
        const arrowClassName = _className(this.state.expanded && 'expanded');
        return _jsxs(LL_V_L, { className: 'smart-doc__info-container', children: [_jsxs(LL_H_C, { className: 'smart-doc__actions', children: [canEdit &&
                            _jsx(ICONS.advisor_v5_freeText.component, { className: 'smart-doc__edit-icon', onClick: e => {
                                    stopPropagation(e);
                                    this.props.toggleEdit(smartLog._id);
                                } }), _jsx(ICONS.advisor_v4_arrow.component, { className: arrowClassName })] }), _jsx("span", { className: 'timestamp', children: formatTimestamp('hh:mma', smartLog.timeCreated) })] });
    };
}
//# sourceMappingURL=Renderer_SmartLog.js.map